import { confirmAction } from './confirmAction';

type ConfirmSoftDeleteOptions = {
  entityLabel: string;
  recordName: string;
  confirmText?: string;
  onConfirm: () => void | Promise<void>;
};

export function confirmSoftDelete({
  entityLabel,
  recordName,
  confirmText = 'Delete',
  onConfirm,
}: ConfirmSoftDeleteOptions) {
  confirmAction({
    title: `Delete ${entityLabel}`,
    message: `"${recordName}" will be removed from active configuration. Existing historical records stay linked to this ${entityLabel.toLowerCase()}.`,
    confirmText,
    destructive: true,
    onConfirm,
  });
}
